import { FileText, FileType2, Presentation, FileArchive, Image as ImageIcon, ExternalLink, Mail, Megaphone, MonitorPlay, Printer, Share2 } from "lucide-react";
import { mediaUrl } from "@/lib/academy";

export const FILE_META = {
  pdf: { label: "PDF", icon: FileText },
  docx: { label: "DOCX", icon: FileType2 },
  pptx: { label: "PPTX", icon: Presentation },
  zip: { label: "ZIP", icon: FileArchive },
  image: { label: "Image", icon: ImageIcon },
  canva: { label: "Canva", icon: ExternalLink },
};

export const SECTION_META = {
  "Prospect Outreach": { icon: Mail, tint: "from-emerald-500/25 to-teal-500/10 text-emerald-400" },
  "Sales Materials": { icon: Megaphone, tint: "from-amber-500/25 to-orange-500/10 text-amber-400" },
  "Presentations": { icon: MonitorPlay, tint: "from-sky-500/25 to-cyan-500/10 text-sky-400" },
  "Print Marketing": { icon: Printer, tint: "from-rose-500/25 to-pink-500/10 text-rose-400" },
  "Social & Digital Assets": { icon: Share2, tint: "from-violet-500/25 to-fuchsia-500/10 text-violet-400" },
};

export const ASSET_ACCEPT = ".pdf,.docx,.pptx,.zip,.png,.jpg,.jpeg";

export const fileTypeFromName = (name = "") => {
  const ext = name.split(".").pop().toLowerCase();
  if (["png", "jpg", "jpeg"].includes(ext)) return "image";
  return ["pdf", "docx", "pptx", "zip"].includes(ext) ? ext : null;
};

export const MIME_BY_TYPE = {
  pdf: "application/pdf",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  zip: "application/zip",
};

export const downloadHref = (a) => {
  if (!a.file_url) return null;
  if (a.file_type === "canva") return a.file_url;
  const u = mediaUrl(a.file_url);
  return a.file_url.startsWith("/api/academy/media/") || a.file_url.startsWith("/api/marketing/library/") ? `${u}?download=1` : u;
};
